import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermission } from '../../api/permissions/PermissionContext';

interface ProtectedRouteProps {
  requireAdmin?: boolean;
  redirectPath?: string;
}

/**
 * Componente para proteger rutas que requieren autenticación
 * Si el usuario no está autenticado, redirige a la página de login
 * Si requireAdmin es true, también verifica que el usuario sea administrador
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = React.memo(({
  requireAdmin = true,
  redirectPath = '/admin/login',
}) => {
  const { currentUser, can } = usePermission();
  const isLoading = false; // Permission context derives from Auth; loading handled upstream

  // Mientras se verifica la autenticación, mostrar un indicador de carga
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Verificar autenticación y rol si es necesario
  const isAuthenticated = !!currentUser;
  const isAuthorized = isAuthenticated && (!requireAdmin || can('user.manage', 'users'));
  console.log('[ProtectedRoute] isAuthenticated=', isAuthenticated, 'isAuthorized=', isAuthorized);

  // Si no está autorizado, redirigir a la página de login
  if (!isAuthorized) {
    return <Navigate to={redirectPath} replace />;
  }

  // Si está autorizado, renderizar los componentes hijos
  console.log('[ProtectedRoute] rendering Outlet');
  return <Outlet />;
});

export default ProtectedRoute;